/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_Reading_HistoryInputs */

const en_us2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking at your history…`)
};

const pt_br2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olhando o seu histórico…`)
};

const es_419_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mirando tu historial…`)
};

const pt_pt2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ver o teu histórico…`)
};

const fr_fr2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture de ton historique…`)
};

const de_de2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehe mir deinen Verlauf an…`)
};

const it_it2_coach_extra_activity_reading_history = /** @type {(inputs: Coach_Extra_Activity_Reading_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardo il tuo storico…`)
};

/**
* | output |
* | --- |
* | "Looking at your history…" |
*
* @param {Coach_Extra_Activity_Reading_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_reading_history = /** @type {((inputs?: Coach_Extra_Activity_Reading_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_Reading_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_reading_history(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_reading_history(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_reading_history(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_reading_history(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_reading_history(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_reading_history(inputs)
	return en_us2_coach_extra_activity_reading_history(inputs)
});
export { coach_extra_activity_reading_history as "coach-extra.activity_reading_history" }